import { render, staticRenderFns } from "./income-export.vue?vue&type=template&id=1212f522"
import script from "./income-export.vue?vue&type=script&lang=js"
export * from "./income-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports